import { gql } from 'apollo-angular';

export const TipTapDocumentFragment = gql`
  fragment TipTapDocumentFields on TipTapDocumentOutputGraphql {
    id
    name
    data
  }
`;
